import React, { useMemo } from 'react';
import CustomSelect from './CustomSelect';
import { ALL_CITIES, POPULAR_CITIES } from './Cities';

const CitySelect = ({ value, onChange, styles, ...props }) => {
  const cityOptions = useMemo(
    () => ALL_CITIES.map(city => ({ value: city, label: city })),
    []
  );

  const popularOptions = useMemo(
    () => POPULAR_CITIES.map(city => ({ value: city, label: city })),
    []
  );

  const noOptionsMessage = ({ inputValue }) => {
    if (!inputValue || inputValue.length === 0) {
      return 'Начните вводить название города...';
    }
    if (inputValue.length === 1) {
      return 'Введите 2+ символа для поиска по всем городам';
    }
    return 'Город не найден';
  };

  return (
    <CustomSelect
      allOptions={cityOptions}
      popularOptions={popularOptions}
      value={value}
      onChange={onChange}
      placeholder="Выберите город..."
      noOptionsMessage={noOptionsMessage}
      styles={styles}
      {...props}
    />
  );
};

export default CitySelect;